import { inject, observer } from 'mobx-react';
import React from 'react';

import { Button, Dialog } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

@inject('userStore')
@inject('dialogStore')
@observer
export default class Message extends React.Component {
    render() {
        const { messageDialogOpen, messageDialogBody, messageDialogTitle, closeAll } = this.props.dialogStore;

        return (
            <Dialog
                title={messageDialogTitle}
                modal={false}
                open={messageDialogOpen}
                overlayClassName="vulners-dialog-overlay"
                titleClassName="vulners-dialog-title"
                bodyClassName="vulners-dialog-body"
                onClose={closeAll}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{messageDialogBody}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={closeAll}>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
